var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_vm._v("\n  TODO: Hier Idee mit der täglichen Checkliste aus Audibook\n  \"The Motivation Myth\" umsetzten. Zu jedem Goal kann ein Daily Checklist\n  definiert werden.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }